export default __webpack_public_path__ + "static/media/rainbow.77a12752.png";